import Commons from '../../../../Services/Common/Common';

/**
 * SUB_BASIC_02 스키마
 * - fields: 폼/그리드에서 공통으로 쓰는 필드 정의
 *   - initial: 초기값
 *   - label: 필드명
 *   - required: 필수 입력 여부
 *   - requiredWhen: 언제 필수인지 조건
 *
 * - mapper: 조회 API payload 생성 규칙
 *   - mapParamsBySchema(mapper, context)로 payload를 만듬
 *   - context에는 userInfo 등이 들어오며(mapParamsBySchema에 기본적으로 정의되어 있음),
 *     화면에서 추가로 필요한 값(custCd 등)을 context로 넘겨줄 수 있다.
 */
export const SUB_BASIC_02_Schema = {
  fields: {
    custCd: { initial: '', label: '사업장코드' },
    custNm: { initial: '', label: '업체명', required: 'Y' },
    sbmHalf: { initial: '', label: '상반기/하반기' },
    evaluatorOpinion: { initial: '', label: '평가자의견' },
    name: { initial: '', label: '평가자' },
    updateDate: { initial: '', label: '평가일' },
    totalScore: { initial: 0, label: '총배점' },
    startYear: { initial: '', label: '시작연도' },
    endYear: { initial: '', label: '종료연도' },
    searchText: { initial: '', label: '검색어' },
    mstCustCd: { initial: '', label: '사업장코드' },
    partnerCompany: { initial: '', label: '협력업체코드' },
    sbmId: { initial: '', label: '평가표 ID' },
  },

  mapper: {
    search1: {
      CustCd: (_, context) =>
        Commons.EncryptAES(context.search?.custCd || '') || '',
      StartYear: (_, context) =>
        Commons.EncryptAES(context.search?.startYear || '') || '',
      EndYear: (_, context) =>
        Commons.EncryptAES(context.search?.endYear || '') || '',
      SearchText: (_, context) =>
        Commons.EncryptAES(context.search?.searchText || '') || '',
    },
    search2: {
      SbmId: (_, context) => Commons.EncryptAES(context.sbmId || 0) || '',
    },
  },
};
